module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" preserveAspectRatio=\"none\"><path d=\"M285.81 179.765a11.96 11.96 0 0 0-8.483-3.513 11.97 11.97 0 0 0-8.486 3.514 11.962 11.962 0 0 0-3.51 8.486c0 3.315 1.344 6.316 3.517 8.488 2.17 2.17 8.482 7.112 8.482 7.112s6.312-4.943 8.484-7.115a11.962 11.962 0 0 0 3.515-8.485 11.97 11.97 0 0 0-3.518-8.487zM22.957 13.3L13.03 8.53v9.535zM11.71 7.674c.01-1.144-1.99-1.202-1.99-.096v16.207h1.986\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./map/additionalCoreMethods/marker/flag.svg
// module id = 373
// module chunks = 0